import React, {useState} from 'react';
import * as S from './HobBottomSheetStyles'

const HobBottomSheet = ({ isOpen, children, onClose, welcomeText, fontFamily, setInitialText }) => {
  const [showWelcomeName, setShowWelcomeName] = useState(true);
  if (!isOpen) return null;

  setTimeout(() => {
    setInitialText('')
    setShowWelcomeName(false);
  }, 4000)

  return (
    <S.BottomSheetBackdrop isOpen={isOpen} onClick={onClose}>
      <S.BottomSheet isOpen={isOpen} fontFamily={fontFamily} onClick={e => e.stopPropagation()}>
        {showWelcomeName && welcomeText?.length ? (
          <div className='header'>
            {welcomeText}
          </div>
        ) : null}
        {children}
      </S.BottomSheet>
    </S.BottomSheetBackdrop>
  );
};

export default HobBottomSheet;